import React, { useCallback, useEffect, useState } from 'react'
import {
  CAccordion,
  CAccordionItem,
  CAccordionHeader,
  CAccordionBody,
  CRow,
} from '@coreui/react-pro'

import Table from './Table'
import AddForm from './AddForm'
import GamePrizeService from 'src/service/GamePrizeService'

const GamePrize = () => {
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(false)

  // ✅ SAME AS ROUND
  const fetchUsers = useCallback(async () => {
    setLoading(true)
    try {
      const res = await GamePrizeService.getPrize() // adjust API if needed
      setUsers(res.data)
    } catch (e) {
      console.log(e)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchUsers()
  }, [fetchUsers])

  return (
    <CRow>
      {/* CREATE */}
      <CAccordion activeItemKey={1} alwaysOpen>
        <CAccordionItem itemKey={1}>
          <CAccordionHeader>
            <strong>Create Prize</strong>
          </CAccordionHeader>
          <CAccordionBody>
            <AddForm fetchUsers={fetchUsers} />
          </CAccordionBody>
        </CAccordionItem>
      </CAccordion>

      {/* MANAGE */}
      <CAccordion activeItemKey={1}>
        <CAccordionItem itemKey={1}>
          <CAccordionHeader>
            <strong>Manage Prizes</strong>
          </CAccordionHeader>
          <CAccordionBody>
            <Table
              users={users}
              fetchUsers={fetchUsers} // ✅ IMPORTANT
              loading={loading}
            />
          </CAccordionBody>
        </CAccordionItem>
      </CAccordion>
    </CRow>
  )
}

export default GamePrize
